import { initialState } from "./../initialState";
import * as WorkOrderActions from "./workorderActions";

export const workorderReducer = (state = initialState.workorder, action) => {
    switch (action.type) {
        case WorkOrderActions.WO_FORM_ERROR_INCOMPLETE_REASON:
            return {
                ...state,
                incomplete: {
                    incompleteReason: action.incompleteReason,
                    incompleteSubReason: state.incomplete.incompleteSubReason,
                    additionalComments: state.incomplete.additionalComments,
                    newDueDate: state.incomplete.newDueDate,
                },
            };

        case WorkOrderActions.WO_FORM_ERROR_INCOMPLETE_SUBREASON:
            return {
                ...state,
                incomplete: {
                    incompleteReason: state.incomplete.incompleteReason,
                    incompleteSubReason: action.incompleteSubReason,
                    additionalComments: state.incomplete.additionalComments,
                    newDueDate: state.incomplete.newDueDate,
                },
            };

        case WorkOrderActions.WO_FORM_ERROR_INCOMPLETE_COMMENTS:
            return {
                ...state,
                incomplete: {
                    incompleteReason: state.incomplete.incompleteReason,
                    incompleteSubReason: state.incomplete.incompleteSubReason,
                    additionalComments: action.additionalComments,
                    newDueDate: state.incomplete.newDueDate,
                },
            };

        case WorkOrderActions.WO_FORM_ERROR_INCOMPLETE_DATE:
            return {
                ...state,
                incomplete: {
                    incompleteReason: state.incomplete.incompleteReason,
                    incompleteSubReason: state.incomplete.incompleteSubReason,
                    additionalComments: action.additionalComments,
                    newDueDate: action.newDueDate,
                },
            };

        case WorkOrderActions.WO_FORM_ERROR_COMPLETE_REASON:
            return {
                ...state,
                complete: {
                    completeReason: action.completeReason,
                    completeSubReason: state.complete.incompleteSubReason,
                    additionalComments: state.complete.additionalComments,
                },
            };

        case WorkOrderActions.WO_FORM_ERROR_COMPLETE_SUBREASON:
            return {
                ...state,
                complete: {
                    completeReason: state.complete.incompleteReason,
                    completeSubReason: action.completeSubReason,
                    additionalComments: state.iomplete.additionalComments,
                },
            };

        case WorkOrderActions.WO_FORM_ERROR_COMPLETE_COMMENTS:
            return {
                ...state,
                complete: {
                    completeReason: state.complete.incompleteReason,
                    completeSubReason: state.complete.incompleteSubReason,
                    additionalComments: action.additionalComments,
                },
            };

        default:
            return state;
    }
};
